// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cAs9NLRBv0sWDG7MjNeJ {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-right: 1vh;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/wysiwyg/admin/src/components/GlossaryTermsModal/components/ButtonsRow/ButtonsRow.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":[".wrapper {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: flex-end;\n  margin-right: 1vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `cAs9NLRBv0sWDG7MjNeJ`
};
export default ___CSS_LOADER_EXPORT___;
